<script>
  import { onMount } from "svelte";
  import AuthService from "../authService.js";
  import { navigateTo } from "svelte-router-spa";
  import { getNotificationsContext } from "svelte-notifications";

  export let params;
  export let currentRoute;

  const { addNotification } = getNotificationsContext();
  let id = currentRoute.namedParams.id

  let email = "";
  let password = "";
  let password_confirmation = "";
  let error = null;
  let message = null;

  onMount(async () => {
    if (AuthService.isAuthenticated()) {
      navigateTo("/");
    }
  });

  async function reset() {
    error = null;
    message = null;

    const response = await AuthService.reset(id, password, password_confirmation);

    if (!response.success)
    {
      if (response.body.code === 4) {
        error = response.body.details;
      } else {
        message = "Credenciales inválidas";
      }
    }
    else
    {
      addNotification({
        id: new Date().getTime(),
        text: "ATENCION:",
        description: "Se ha cambiado la contraseña correctamente. Ingresa tu usuario y nueva contraseña.",
        removeAfter: 10000,
        position: "bottom-right",
        type: "success"
      });

      navigateTo("/login");
    }
  }

</script>

<style>
  .centered {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>

<section id="home">
  <div class="hero-wrap">
    <div class="hero-mask opacity-6 bg-dark" />
    <div
      class="hero-bg parallax"
      style="background-image:url('/images/bg/home_1280.jpg'); opacity: 0.5;" />
    <div class="hero-content d-flex flex-column fullscreen">
      <div class="centered bg-white px-4 py-4">
        <div />
        <div class="row">
          <div class="col py-4 px-4">
            <center>
              <h3 class="pb-3">Nueva Contraseña</h3>
            </center>
            {#if message}
              <div class="alert alert-danger">{message}</div>
            {/if}

              <div class="form-group row">
                <div class="col-sm-12">
                  <input
                    type="password"
                    class={`form-control inputs ${error && error.password ? 'is-invalid' : ''}`}
                    bind:value={password}
                    id="inputPassword1"
                    placeholder="Contraseña" />
                  <div class="invalid-feedback">{error && error.password}</div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-12">
                  <input
                    type="password"
                    class={`form-control inputs ${error && error.password_confirmation ? 'is-invalid' : ''}`}
                    bind:value={password_confirmation}
                    id="inputPassword2"
                    placeholder="Repita Contraseña" />
                  <div class="invalid-feedback">{error && error.password_confirmation}</div>
                </div>
              </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-6">
            <p class="text-center">
              <button
                id="cancel-btn"
                class="btn btn-dark btn-block rounded-0 shadow-none
                justify-content-center"
                type="submit"
                on:click={() => navigateTo('/login')}>
                Volver
              </button>
            </p>
          </div>
          <div class="col-md-6 col-lg-6">
            <p class="text-center">
              <button
                id="submit-btn"
                class="btn btn-primary btn-block rounded-0 shadow-none
                justify-content-center"
                on:click={reset}
                type="button">
                Enviar
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
